<template>
  <div>
    <div class="row">
      <div class="col-sm-6 insights-unusual-activity-widget">
        <div class="d-flex align-items-baseline">
          <strong>Unusual activity</strong>
        </div>
        <div class="insights-unusual-activity-widget-chart d-flex flex-column">
          <div class="chart-wrapper d-flex flex-column align-items-center justify-content-center">
            <InsightsUnusualActivityChart
              class="mb-20 mt-20"
              :chart="unusualActivityChart"
              :data="unusualActivityChartData"
              expanded
              :loading="false"
              :total-incidents="totalIncidents"
            />
            <AppChartLegend
              class="dashboard-widget"
              :values="legendData"
              has-tooltips
              orientation="vertical"
            />
          </div>
        </div>
      </div>
      <div class="col-sm-6 insights-work-time-classification-widget">
        <div class="d-flex align-items-baseline">
          <strong>Work time classification</strong>
        </div>
        <div class="widget-body">
          <div class="with-data">
            <div class="d-flex">
              <div class="core-work mt-15">
                <strong>34%</strong>
                <span>Core work</span>
              </div>
            </div>
            <AppChartLineStacked
              class="mt-20"
              :values="workTimeClassificationChartData"
              has-tooltips
            />
            <AppChartLegend
              class="dashboard-widget"
              :values="workTimeClassificationLegendData"
              orientation="vertical"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="widget-footer">
      <div class="is-block px-30 mt-10 text-center">
        <a
          :href="insightsUrl"
          class="btn btn-primary"
        >
          Check out Insights
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import InsightsUnusualActivityChart from '~/components/insights/InsightsUnusualActivityChart.vue';
import AppChartLineStacked from '~/components/AppChartLineStacked.vue';
import AppChartLegend from '~/components/AppChartLegend.vue';
import { InsightsResource } from '~/resources';
import { INSIGHTS } from '~/app_constants';

export default {
  name: 'InsightsExampleDashboardWidget',
  components: {
    AppChartLineStacked,
    InsightsUnusualActivityChart,
    AppChartLegend,
  },
  props: {
    organizationId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    totalIncidents() {
      return 21;
    },
    unusualActivityChart() {
      return {
        high_activity: 9.3,
        long_period_of_single_activity_without_mouse: 11.3,
        long_period_of_single_activity_without_typing: 28.5,
        suspicious_app: 72.2,
      };
    },
    legendData() {
      return this.unusualActivityChartData.map((label) => ({
        ...label,
        tooltip: INSIGHTS.unusualActivity.labels[label.key].tooltip,
      }));
    },
    workTimeClassificationLegendData() {
      return this.workTimeClassificationChartData.map((label) => ({ ...label, tooltip: label.tooltip }));
    },
    workTimeClassificationChartData() {
      return [
        {
          key: 'core',
          label: 'Core work',
          value: 34,
          tools: [],
          tooltip:
            '<ul class="list-unstyled m-0 text-left"><li>55% VS Code</li><li>21% Adobe Photoshop</li><li>8% Terminal</li><li>3% Figma</li><li>5% RubyMine</li></ul>',
        },
        {
          key: 'non-core',
          label: 'Non-core work',
          value: 56,
          tools: [],
          tooltip:
            '<ul class="list-unstyled m-0 text-left"><li>83% Slack</li><li>5% Hubstaff</li><li>5% Outlook</li><li>5% RubyMine</li><li>1% Zoom</li></ul>',
        },
        {
          key: 'unproductive',
          label: 'Unproductive',
          value: 10,
          tools: [],
          tooltip:
            '<ul class="list-unstyled m-0 text-left"><li>79% Whatsapp</li><li>11% Discord</li><li>7% Spotify</li></ul>',
        },
      ];
    },
    unusualActivityChartData() {
      return [
        {
          key: 'suspicious-activity',
          label: 'Suspicious app / URL',
          value: 9.3,
          tooltip: '<div class="d-flex flex-column"><div>9 instances</div><div>Suspicious app / URL</div></div>',
        },
        {
          key: 'long-period-of-single-activity-without-mouse',
          label: 'Predominantly keyboard usage',
          value: 11.3,
          tooltip: '<div class="d-flex flex-column"><div>28 instances</div><div>Predominantly keyboard usage</div></div>',
        },
        {
          key: 'long-period-of-single-activity-without-typing',
          label: 'Predominantly mouse usage',
          value: 28.5,
          tooltip: '<div class="d-flex flex-column"><div>28 instances</div><div>Predominantly mouse usage</div></div>',
        },
        {
          key: 'high-activity',
          label: 'Unusually high activity',
          value: 72.2,
          tooltip: '<div class="d-flex flex-column"><div>72 instances</div><div>Unusually high activity</div></div>',
        },
      ];
    },
    insightsUrl() {
      return InsightsResource.insightsLink(
        { organizationId: this.organizationId },
        {
          event: 'cta_dialog_viewed',
          src: 'insights_example_dashboard_widget',
        },
      );
    },
  },
};
</script>
